import React from 'react';

export default function HoverSelectionWindow({ text }) {
  if (!text) return null;
  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "300px",
        maxHeight: "200px",
        overflowY: "auto",
        background: "rgba(255, 255, 255, 0.95)",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontSize: "14px",
        lineHeight: "1.4",
        whiteSpace: "pre-wrap",
      }}
    >
      <strong>Selected Text:</strong>
      <div style={{ marginTop: "5px" }}>{text}</div>
    </div>
  );
}